import { memo } from "react";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { HourglassTop } from "@mui/icons-material";
import dayjs from "dayjs";
import type { PendingProviderRequest } from "../services/affiliationRequestService";

/**
 * Afiliada com pedido enviado: aguardando a prestadora aprovar.
 * "Verificar agora": a aprovação não chega por notificação.
 * "Cancelar pedido": libera para escolher outra prestadora (ou prestar).
 */
export const PendingProviderRequestCard = memo(function PendingProviderRequestCard({
  request,
  isBusy,
  onCheck,
  onCancel,
}: {
  request: PendingProviderRequest;
  isBusy: boolean;
  onCheck: () => void;
  onCancel: () => void;
}) {
  const requestedOn = request.requestedOn ? dayjs(request.requestedOn).format("DD/MM/YYYY") : "";

  return (
    <Paper variant="outlined" sx={{ p: 3, borderLeft: "4px solid", borderLeftColor: "warning.main" }}>
      <Stack spacing={1.5}>
        <Stack direction="row" spacing={1} alignItems="center">
          <HourglassTop color="warning" aria-hidden />
          <Typography variant="h6" fontWeight={700}>
            Aguardando aprovação de {request.providerName}
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {requestedOn ? `Pedido enviado em ${requestedOn}. ` : ""}
          Quando {request.providerName} aprovar, sua clínica poderá marcar teleconsultorias
          com os teleconsultores dela.
        </Typography>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
          <Button variant="contained" onClick={onCheck} disabled={isBusy} sx={{ textTransform: "none" }}>
            Verificar agora
          </Button>
          <Button color="error" onClick={onCancel} disabled={isBusy} sx={{ textTransform: "none" }}>
            Cancelar pedido
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
});
